import React from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

import { MainHeadingWrapper } from "../../Elements/Elements";
import ProjectCard from "./ProjectCard";
import ProjectDetail from "./ProjectDetail";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "scroll",
    padding: "100px 0 ",
  },
}));

const BridgeTwo = styled.div`
  padding-top: 75px;
  width: 100%;
  margin: 0 auto;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.fontColor};

  /* min-height: 400px; */
  z-index: 99;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  > div:nth-child(2) {
    padding: 50px 0;
    border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    grid-row-gap: 20px;
    width: 90%;
    margin: 30px auto;
    align-items: center;
    justify-content: space-evenly;
    background-size: cover;
    background-position: center;
  }
`;

let projectArray = [
  {
    img: "https://raw.githubusercontent.com/KapoorKartik/Udemy-Clone/main/Screenshot/Screenshot%20(557).png",
    title: "Udemy",
    description: "Udemy is an online learning and teaching marketplace where students can learn programming, marketing, data science and more.",
    techStack: [
      "HTML",
      "CSS",
      "JavaScript",
      // "React",
      // "MaterialUI",
      "Node",
      // "Express",
      // "MongoDB",
      
    ],
    repoLink: "https://github.com/KapoorKartik/Udemy-Clone",
    demoLink: "https://kapoorkartik.github.io/Udemy-Clone/home_page.html",
    type: "A collaborative project built by a team of 5 members under 2 weeks.",
    // blogLink: "https://medium.com/@shashank0194/your-ev-assistant-a1b1910297fe",
    features: [
      "Home Page",
      "Signup and Login.",
      // "Course Page",
      "A user can view Course Details.",
      "A user can add Course to the Cart.",
      "A user can apply PromoCode.",
      "A user can make Payment",
    ],
  },

  {
    img: "https://github.com/Rohit-0310/strawberrynet-clone/raw/main/strawberrynet.jpg",
    title: "Strawberry.Net",
    description: "Strawberry.Net is E-Commerce website which is dealing with Cosmetic products.",
    techStack: [
      "HTML",
      "CSS",
      "JavaScript",
      // "NextJs",
      "Node",
      "Express",
      "MongoDB",
    ],
    repoLink: "https://github.com/yssambare12/strawberrynetwithbackend.github.io",
    demoLink: "https://yssambare12.github.io/strawberrynetwithbackend.github.io/",
    type: "A collaborative project built by a team of 6 members.",
    // blogLink: "https://medium.com/@shashank0194/cloning-of-zoomcar-com-website-using-backend-53138db640fb",
    features: [
      "Signup and Login.",
      "Users can view product pages",
      "Users can add products to the cart or buy products",
      "Users can make payments through net banking, credit card, and debit card.",
      "Users can also see the status of the Products.",
    ],
    // responsibilities: [
    //   "Developed the module for users and authentication for users and integrated it with the front-end",
    //   "Laid out the database schema and build CRUD API for user authentication.",
    //   "Developed Sign Up, Login, OTP, Checkout page. ",
    // ],
  },
  {
    img: "https://github.com/Spratham72/Aha-Clone/blob/main/public/Screenshots/home.png?raw=true",
    title: "Aha ",
    description:
      "Aha is an Indian subscription video on-demand and over-the-top streaming service which offers Telugu-language content.",

    techStack: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "MaterialUI",
      "Node",
      "Express",
      "MongoDB",
    ],
    repoLink: "https://github.com/Spratham72/Aha-Clone#aha-clone",
    demoLink: "https://aha-raman-boddula.vercel.app/",
    type: "A collaborative project built by a team of 4 executed in 6 days.",
    blogLink:
      "https://medium.com/@spratham72/clone-of-aha-e0acfb27239a",
    features: [
      "Login and Signup",
      "Home Page",
      "User can viwe Movie Details Page",
      "User can buy Subscription",
      "kids Page",
    ],
    // responsibilities: [
    //   "Built REST API and integrated it with the frontend.",
    //   "Laid out the database schema and built authentication.",
    //   "Developed the Home and Tariff page.",
    //   "Integrated the frontend and backend.",
    // ],
  },

  {
    img: "https://raw.githubusercontent.com/Rohit-0310/PharmEasy/main/src/IMG/pharmEasy_HomePage.png",
    title: "PharmEasy",
    description:
      "PharmEasy is a health tech startup offering services such as teleconsultation, medicine deliveries, and diagnostic test sample collections.",
    techStack: [
      "React",
      "Redux",
      "MaterialUI",
      "JSONServer",
      "HTML",
      "CSS",
      "JavaScript",
  ],
    repoLink: "https://github.com/Rohit-0310/PharmEasy",
    demoLink: "https://pharmeasy-five.vercel.app/",
    type: "Solo project",
    blogLink:
      "https://github.com/Rohit-0310/PharmEasy",
    features: [
      "Login and Signup",
      "Home Page",
      "User can viwe Category Dateils ",
      "Users can view products pages",
      "Users can view products Details pages",
      "Users can add products to the cart or buy products",
      "Users can make payments through net banking, credit card, and debit card.",
      
    ],
  },


   {
    img: "https://raw.githubusercontent.com/Rohit-0310/Weather-App/main/src/ICON/image.png",
    title: "Weather App",
    description:
      "An app where user can find hourly, and daily forecasts as well as current Temperature. It shows Pressure, Humidity, Sunset, and Sunrise",
    techStack: [
      "React",
    "MaterialUI",
    // "HTML",
    "CSS",
    "JavaScript",],
    repoLink: "https://github.com/Rohit-0310/Weather-App",
    demoLink: "https://weather-rohit.vercel.app/",
    type: "Solo project",
    blogLink: "#",
    features: [
      "It shows the current temperature.",
      "Daily minimum and maximum temperature on top in a row.",
      "Hourly temperature in the graph.",
      "Pressure in the hPa unit.",
      "Humidity in the percentage unit.",
      "Sunrise and Sunset time.",
    ],
  },



  {
    img: "https://raw.githubusercontent.com/Rohit-0310/portfolio/main/images/LMS_Home_Page.png",
    title: "Masai LMS",
    description:
      "An app where students can find the Schedule of the days and Previous lectures and assignments. as well as Admin can release the schedule and assignment for the day.",
    techStack: [
        "React",
        "MaterialUI",
        "Node",
        "Express",
        "MongoDB",
        "HTML",
        "CSS",
        "JavaScript",
    ],
    repoLink: "https://github.com/Rohit-0310/LMS",
    demoLink: "https://masai-lms.vercel.app/",
    type: "Solo project",
    blogLink: "#",
    features: [
      "Login, Signup and Logout authentication using firebase",
      "Dashboard where student can find Schedule of the days",
      "Lecture Page where student can find Old lectures",
      "Assignmrnt Page where student can find Old assignmrnts",
      "Admin Page where Admin can release the Schedule of the days",
      "Connected MongoDB database with a Node.js server to perform CRUD operations(Add Lecture and Assignment).",
    ],
  },


  // {
  //   img: "https://user-images.githubusercontent.com/39058941/118371705-7d4b2f80-b5cb-11eb-9cfd-a5a917f759e0.png",
  //   title: "Product Hunt ",
  //   description:
  //     "An online product portal where users can browse, research, and post products. ",
  //   techStack: ["HTML", "CSS", "JavaScript", "React", "MaterialUI"],
  //   repoLink: "https://github.com/therealdrtroll/product-hunt",
  //   type: "A collaborative project built by a team of 4 under 4 days.",
  //   demoLink: "https://producthuntalpha.netlify.app/",
  //   blogLink:
  //     "https://ar1pperk.medium.com/how-can-you-collab-remotely-to-develop-an-effective-product-in-4-days-ff3d2a0168dd",
  //   features: [
  //     "Research products and post products.",
  //     "Research jobs and post jobs.",
  //     "Raise a discussion and comment under it.",
  //     "Book an appointment with your favourite product mentor.",
  //   ],

  //   responsibilities: [
  //     "Scraped data from the original product hunt.",
  //     "Developed pixel-perfect UI of the product page.",
  //     "Implemented features like up-vote, share, and single product modal.",
  //   ],
  // },
];

function Projects() {
  const [panel, setPanel] = React.useState(false);
  let [currentProject, setCurrentProject] = React.useState({});
  const classes = useStyles();
  return (
    <div id="projects">
      <BridgeTwo backgroundImg={currentProject.img}>
        <MainHeadingWrapper>
          <h1>Projects</h1>
          <div></div>
        </MainHeadingWrapper>
        <div>
          {projectArray?.map((project) => (
            <ProjectCard
              key={project.title}
              setCurrentProject={setCurrentProject}
              setPanel={setPanel}
              {...project}
            ></ProjectCard>
          ))}
        </div>
        <Modal
          className={classes.root}
          open={panel}
          onClose={() => setPanel(false)}
        >
          <ProjectDetail
            {...currentProject}
            setPanel={setPanel}
          ></ProjectDetail>
        </Modal>
      </BridgeTwo>
    </div>
  );
}

export default Projects;
